export default __webpack_public_path__ + "static/promontory-logo-black-61440d778a3fb078cb043964f5f2ea1c.svg";